export default __webpack_public_path__ + "static/media/img-48-ilasiaq.c5ad37cb.jpg";